import styled from 'styled-components';
import Form from 'react-bootstrap/Form';

/**
 * Shared styled components for layer settings sidebars
 * These components provide consistent styling across all layer configuration panels
 */

export const SettingsTab = styled.div`
	color: ${props => props.theme.colors.textColor};
	padding: 20px;
`;

export const SettingsGroup = styled(Form.Group)`
	margin-bottom: 25px;
`;

export const SettingsLabel = styled(Form.Label)`
	opacity: 0.7;
	font-size: 1rem;
	font-weight: 600;
	text-transform: capitalize;
	display: block;
	margin-bottom: 10px;
`;

export const SettingsSelect = styled(Form.Select)`
	background-color: ${props => props.theme.colors.backgroundInput};
	border: 1px solid ${props => props.theme.colors.borderInput};
	color: ${props => props.theme.colors.textColor};

	&:focus {
		background-color: ${props => props.theme.colors.backgroundInput};
		color: ${props => props.theme.colors.textColor};
	}

	option {
		background-color: ${props => props.theme.colors.backgroundInput};
		color: ${props => props.theme.colors.textColor};
	}
`;

export const SettingsDescription = styled.div`
	font-size: 0.85rem;
	color: ${props => props.theme.colors.textAccent};
	margin-top: 8px;
`;

export const InfoText = styled.div`
	font-size: 0.85rem;
	color: ${props => props.theme.colors.textAccent};
	margin-top: 15px;
`;
